import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import _ from "lodash";
import { Fragment, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import AppFooter from "@components/AppFooter/AppFooter";
import AppNavbar from "@components/AppNavbar/AppNavbar";
import GeneralConst from "@consts/GeneralConst";
import logoBlack from "@images/logos/logoBlack.png";
import FAQService from "@services/FAQService";
import GeneralStrings from "@strings/GeneralStrings.json";
import "./FAQPage.scss";

const title = `FAQ | ${GeneralConst.SITE_NAME}`;
const faqStrings = GeneralStrings.faq;

const FAQPage = () => {
  const [faqs, setFaqs] = useState<FAQ[]>([]);
  const [expandedFaq, setExpandedFaq] = useState<string | false>(false);

  useEffect(() => {
    FAQService.getAllFAQs()
      .then((response) => setFaqs(response?.data ?? []))
      .catch(() => {});
  }, []);

  return (
    <Fragment>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <AppNavbar transparentNavbar={false} />
      <section className="faq-page">
        <div className="container">
          <div className="title-area">
            <h2>{faqStrings.frequentlyAskedQuestions}</h2>
            <div className="separator">
              <img src={logoBlack} className="seperator-img" alt="logo" />
            </div>
          </div>
          <div className="faq-group">
            {!_.isEmpty(faqs) &&
              faqs.map((faq) => {
                const panelId = `faq-panel-${faq.id}`;
                const isExpanded = expandedFaq === panelId;
                return (
                  <Accordion
                    key={panelId}
                    expanded={isExpanded}
                    onChange={(_, expanded) =>
                      setExpandedFaq(expanded ? panelId : false)
                    }
                    disableGutters
                    elevation={0}
                  >
                    <AccordionSummary
                      expandIcon={isExpanded ? <CloseIcon /> : <AddIcon />}
                    >
                      <span className="faq-item__question">{faq.question}</span>
                    </AccordionSummary>
                    <AccordionDetails>
                      <p className="faq-item__answer">{faq.answer}</p>
                    </AccordionDetails>
                  </Accordion>
                );
              })}
          </div>
        </div>
      </section>
      <AppFooter />
    </Fragment>
  );
};

export default FAQPage;
